import { AccountFeatures, AppContext } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import Toggle from "react-toggle";
import LabelHelper from "../common/LabelHelper.jsx";
import Icon from "../common/icon/icon.component.jsx";
import RecurringOptionsDropdown from "../common/recurring-options-dropdown/RecurringOptionsDropdown";
import AnchorWrapper from '../common/rich-text/feature-protection-wrappers/anchorWrapper.component';
import DayOfMonthLabel from '../invoice/recurring/dayofmonthlabel.component.jsx';
import { PROPOSAL_TYPE } from "../state/proposal/ProposalType";
const uuidv4 = require('uuid/v4')

const messages = defineMessages({
    'first_short': {
        id: 'invoice.recurring.day_of_month.first_short',
        defaultMessage: 'st',
    },
    'second_short': {
        id: 'invoice.recurring.day_of_month.second_short',
        defaultMessage: 'nd',
    },
    'third_short': {
        id: 'invoice.recurring.day_of_month.third_short',
        defaultMessage: 'rd',
    },
    'something_first_short': {
        id: 'invoice.recurring.day_of_month.something_first_short',
        defaultMessage: 'st',
    },
    'something_second_short': {
        id: 'invoice.recurring.day_of_month.something_second_short',
        defaultMessage: 'nd',
    },
    'something_third_short': {
        id: 'invoice.recurring.day_of_month.something_third_short',
        defaultMessage: 'rd',
    },
    'something_else_short': {
        id: 'invoice.recurring.day_of_month.something_else_short',
        defaultMessage: 'th',
    },
    'last': {
        id: 'invoice.recurring.day_of_month.last',
        defaultMessage: 'Last day',
    },
})

class RecurringStatementOptions extends Component {

    constructor(props, context) {
        super(props, context)
        const info = this.props.value || {}
        const attr = info.attributes || {}
        this.state = {
            info: info,
            enabled: attr.enabled || false,
            capturePayment: attr.capturePayment || false,
            sendEmail: attr.sendEmail || false,
            dayOfMonth: attr.dayOfMonth || 1,
            contactId: this.props.contactId || '',
            contactType: this.props.contactType || 'persons',
            uniqueId: uuidv4(),
            noSave: this.props.noSave || false,
            editable: this.props.editable || false,
            attachPdf: attr.attachPdf,
            editMode: false,
            hover: false,
            onChange: this.props.onChange || function () { },
            paymentMethod: attr.paymentMethod || "",
            saving: false,
        }
        this.triggerEdit = this.triggerEdit.bind(this)
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
        this.handleUpdateOptions = this.handleUpdateOptions.bind(this)
    }


    componentWillReceiveProps(nextProps) {
        const info = nextProps.value || {}
        const attr = info.attributes || {}
        this.setState({
            info: info,
            enabled: attr.enabled || false,
            capturePayment: attr.capturePayment || false,
            sendEmail: attr.sendEmail || false,
            dayOfMonth: attr.dayOfMonth || 1,
            contactId: nextProps.contactId || null,
            contactType: nextProps.contactType || 'persons',
            paymentMethod: attr.paymentMethod || "",
        })
    }

    componentDidMount() { }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    save(event) {
        event.preventDefault()
        let data = {
            dayOfMonth: parseInt(this.state.dayOfMonth),
            capturePayment: this.state.capturePayment,
            sendEmail: this.state.sendEmail,
            attachPdf: this.state.attachPdf,
            enabled: this.state.enabled,
            paymentMethod: this.state.paymentMethod,
        }
        if (this.state.noSave) {
            const info = { attributes: data }
            this.state.onChange(info)
            this.setState({
                info: info,
                editMode: false,
            })
            return
        }
        this.setState({ saving: true })
        AppContext.getApiClient().patch('/' + this.state.contactType + '/' + this.state.contactId, {
            recurringStatement: data,
        }).then((r) => {
            this.state.onChange(r.attributes.recurringStatement)
            this.setState({
                info: r.attributes.recurringStatement,
                editMode: false,
                saving: false,
            })
        })
    }

    handleFocus(event) {
        event.target.select()
    }

    renderText() {
        const info = this.state.info || {}
        const attr = info.attributes || {}
        let label = ''
        let icon = <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} />
        if (!this.state.editable) {
            icon = ''
        }
        if (attr.capturePayment && attr.sendEmail) {
            label = <FormattedMessage
                id="contacts.statement.recurring.options.send_email_and_capture_payment"
                defaultMessage="Automatically send emails and capture payments"
            />
        } else if (attr.capturePayment && !attr.sendEmail) {
            label = <FormattedMessage
                id="contacts.statement.recurring.options.capture_payment_without_email"
                defaultMessage="Automatically capture payment without sending email"
            />
        } else if (!attr.capturePayment && attr.sendEmail) {
            label = <FormattedMessage
                id="contacts.statement.recurring.options.send_email_only"
                defaultMessage="Automatically send emails"
            />
        } else {
            label = <FormattedMessage
                id="contacts.statement.recurring.options.no_payment_and_no_email"
                defaultMessage="Only create statement"
            />
        }
        if (!attr.enabled) {
            return <FormattedMessage
                id="contacts.statement.recurring.options.none"
                defaultMessage="None"
            />
        }

        return <span>
            <FormattedMessage
                id="contacts.statement.recurring.options.send_invoice_in_advance"
                defaultMessage="{label} on the {day} of every month"
                values={{
                    label: label,
                    day: <DayOfMonthLabel dayOfMonth={attr.dayOfMonth} />,
                }}
            />
            {icon}
        </span>
    }

    renderInput() {
        const lines = []
        lines.push(<div key={lines.length} className={'w-100 d-flex'}>
            <div className="mr-2">
                <Toggle
                    id={"enabled"}
                    defaultChecked={this.state.enabled}
                    checked={this.state.enabled}
                    icons={false}
                    onChange={() => { this.setState({ enabled: !this.state.enabled }) }} />
            </div>
            <label className="" htmlFor="sendEmail">
                <FormattedMessage
                    id="contacts.statement.recurring.options.enabled"
                    defaultMessage="Enabled"
                />
            </label>
        </div>)
        if (!this.state.enabled) {
            return lines
        }
        lines.push(<div key={lines.length} className={'w-100 d-flex'}>
            <div className="mr-2">
                <Toggle
                    id={"sendEmail"}
                    defaultChecked={this.state.sendEmail}
                    checked={this.state.sendEmail}
                    icons={false}
                    onChange={() => { this.setState({ sendEmail: !this.state.sendEmail }) }} />
            </div>
            <label className="" htmlFor="sendEmail">
                <FormattedMessage
                    id="contacts.statement.recurring.options.toggle_send_email"
                    defaultMessage="Automatically send emails"
                />
            </label>
        </div>)
        if (this.state.sendEmail && AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureAccountStatements) && AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureStatementAutomation)) {
            lines.push(<div key={lines.length} className={'w-100 d-flex'}>
                <div className="ml-5">
                    <Toggle
                        id={"sendEmail"}
                        defaultChecked={this.state.attachPdf}
                        checked={this.state.attachPdf}
                        icons={false}
                        onChange={() => { this.setState({ attachPdf: !this.state.attachPdf }) }} />
                </div>
                <label className="ml-2" htmlFor="sendEmail">
                    <FormattedMessage
                        id="contacts.statement.recurring.options.toggle_attach_pdf"
                        defaultMessage="Attach account statement pdf"
                    />
                </label>
            </div>)
        }
        lines.push(<div key={lines.length} className={'w-100 d-flex'}>
            <div className="mr-2">
                <Toggle
                    id={"capturePayment"}
                    defaultChecked={this.state.capturePayment}
                    checked={this.state.capturePayment}
                    icons={false}
                    onChange={() => { this.setState({ capturePayment: !this.state.capturePayment }) }} />
            </div>
            <label className="" htmlFor="capturePayment">
                <FormattedMessage
                    id="contacts.statement.recurring.options.toggle_capture_payment"
                    defaultMessage="Automatically capture payments on default card on file (if exists)"
                />
            </label>
        </div>)

        const monthDays = []
        for (let i = 1; i < 29; i++) {
            monthDays.push(i)
        }
        monthDays.push(31)

        if (this.state.sendEmail) {
            lines.push(<p key={lines.length} className={'mb-0'}>
                <FormattedMessage
                    id="contacts.statement.recurring.options.input_day_of_month_send"
                    defaultMessage="Send statement on the {input} of every month"
                    values={{
                        input: <select className="custom-select w-auto" name={'dayOfMonth'} value={this.state.dayOfMonth} onChange={this.handleFormChange}>
                            <option value={1} />
                            {monthDays.map(day => <option key={day} value={day}>{LabelHelper.getDayOfMonthLabel(this.props.intl, day)}</option>)}
                        </select>
                    }}
                />
            </p>)
        } else {
            lines.push(<p key={lines.length} className={'mb-0'}>
                <FormattedMessage
                    id="contacts.statement.recurring.options.input_day_of_month_create"
                    defaultMessage="Create statement on the {input} of every month"
                    values={{
                        input: <select className="custom-select w-auto" name={'dayOfMonth'} value={this.state.dayOfMonth} onChange={this.handleFormChange}>
                            <option value={1} />
                            {monthDays.map(day => <option key={day} value={day}>{LabelHelper.getDayOfMonthLabel(this.props.intl, day)}</option>)}
                        </select>
                    }}
                />
            </p>)
        }

        return lines
    }

    handleFormChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    handleUpdateOptions(options) {
        this.setState({
            enabled: options.enabled,
            attachPdf: options.attachPdf,
            sendEmail: options.sendEmail,
            capturePayment: options.capturePayment,
            paymentMethod: options.paymentMethod,
            dayOfMonth: options.day,
        })
    }

    render() {
        if (!this.state.info) {
            return ''
        }

        if (this.state.editable) {
            return (
                <span>
                    <AnchorWrapper
                        module={AccountFeatures.FeatureStatementAutomation}
                        onClick={(e) => this.triggerEdit(e)}
                        redirectToAccount={true}
                        onMouseLeave={this.onMouseLeaveHandler}
                        onMouseEnter={this.onMouseEnterHandler}
                        className={""}
                        protectedClassName={""}
                        premium={false}
                        protectionRule={AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureStatementAutomation)}
                    >
                        {this.renderText()}
                    </AnchorWrapper>
                    <RecurringOptionsDropdown
                        show={this.state.editMode}
                        canBeDisabled={true}
                        loading={this.state.saving}
                        documentType={PROPOSAL_TYPE.ACCOUNT_STATEMENT}
                        options={{
                            enabled: this.state.enabled,
                            sendEmail: this.state.sendEmail,
                            attachPdf: this.state.attachPdf,
                            capturePayment: this.state.capturePayment,
                            paymentMethod: this.state.paymentMethod,
                            day: this.state.dayOfMonth,
                        }}
                        onUpdate={this.handleUpdateOptions}
                        onClose={this.triggerEdit}
                        onSave={this.save}
                    />
                </span>
            )
        }

        return this.renderText()
    }

}

export default injectIntl(RecurringStatementOptions)





// WEBPACK FOOTER //
// ./src/customer/recurringstatement.component.jsx